import { z } from 'zod'

const collaborativeItemTypeSchema = z.enum([
  'post',
  'reels',
  'live',
  'story',
  'video',
  'shorts',
  'ad_authorization', // 廣告授權
  'material_authorization', // 素材授權
])

type CollaborativeItemType = z.infer<typeof collaborativeItemTypeSchema>

export { collaborativeItemTypeSchema }
export type { CollaborativeItemType }
